<template>
  <div class="server">
    <List />
  </div>
</template>

<script>
import List from './components/list'
export default {
  name: 'index',
  components: {
    List
  }
}
</script>

<style scoped>

</style>
